/** How the staff app names a child everywhere: the name the family uses, or the first name, then the surname. */
export const childName = (child: { preferredName: string | null; firstName: string; lastName: string }) =>
  `${child.preferredName ?? child.firstName} ${child.lastName}`;
